/*
 * Blog product tile
 * -----------------
 * Article bodies can't run Liquid, so a post drops a placeholder:
 *
 *   <div class="sw-product-card"
 *        data-handle="fellow-aiden-precision-coffee-maker"
 *        data-us-handle="fellow-aiden-precision-coffee-maker-matte-black"></div>
 *
 * and this hydrates it client side. One interface covers every case, because both
 * attributes are optional:
 *
 *   data-handle only      gear we sell, nobody else linked
 *   both                  gear we and Espresso Parts both sell, two store rows
 *   data-us-handle only   gear we do not sell, their photo and price carry the tile
 *
 * Every price is fetched live from that store's own product JSON and never stored
 * here, so no row can show a stale figure. Espresso Parts runs on Shopify and
 * serves the same /products/<handle>.js endpoint cross-origin, which is what makes
 * a real tile possible for gear we do not carry.
 *
 * A row whose fetch fails still renders, without a price. The job of the row is to
 * name a store the reader can buy from; the price is a bonus, not the point.
 *
 * The Espresso Parts row carries data-gear-region-item="us" and is hidden from
 * Canadian readers by assets/gear-region.js, since they cannot buy from it.
 */
(function () {
  var US_ORIGIN = 'https://www.espressoparts.com';
  var US_STORE = 'Espresso Parts';
  var US_REF = '?rfsn=9307027.4af22fa';
  var OUR_STORE = 'Stillwater';

  function money(cents) {
    /* Whole dollars when it is whole, and grouped: "$6620" on a six-thousand
       dollar machine reads like a typo. */
    var parts = (cents / 100).toFixed(2).replace(/\.00$/, '').split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.split('?')[0] + '?width=600';
  }

  function fetchProduct(origin, handle) {
    if (!handle) return Promise.resolve(null);
    return fetch(origin + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* The "Save $X with a coffee subscription" note was removed 2026-09-03 when the
     10% gear discount was retired: Dean deleted the admin discount because buyers
     subscribed for one month, took the discount and cancelled. The note's own rule
     was that it must never advertise a discount checkout would not honour, and
     with the discount gone that is every tile. Deleting it also drops up to four
     collection fetches per page load, since eligibility was its only caller. */

  /* Wirecutter shape: the price and the store live IN the button, so a reader
     scanning the page gets "$998 from Amazon" in one glance instead of parsing a
     row of columns.

     Currency is deliberately unlabelled, which is only safe because a reader ever
     sees ONE store's price: ours to Canadians, theirs to Americans. Showing an
     unlabelled $525 CAD above an unlabelled $399.95 USD would read as us being a
     third more expensive when converted we are cheaper. We do not ship gear to the
     US and they do not ship here, so one row per reader is also just the truth
     about where they can buy. */
  function row(o) {
    var label = (o.price != null ? money(o.price) + ' from ' : 'Buy from ') + o.store;
    return '<div class="sw-pc__row" data-gear-region-item="' + o.region + '">' +
             o.cta.replace('{label}', esc(label)) +
           '</div>' +
           (o.note ? '<p class="sw-pc__note" data-gear-region-item="' + o.region + '">'
                     + esc(o.note) + '</p>' : '');
  }

  function ourRow(p) {
    var soldout = !p.available;
    var variant = (p.variants || []).filter(function (v) { return v.available; })[0]
                  || (p.variants || [])[0] || {};
    /* Sold out: link to the product page as a plain "Buy from Stillwater" with
       the primary styling dropped, the same treatment enrichStoreCtas gives a
       sold-out retailer. We never publish stock status, ours or anyone's. */
    var cta = soldout
      ? '<a class="button sw-pc__btn" href="' + p.url + '">{label}</a>'
      : '<form action="/cart/add" method="post" class="sw-pc__form">' +
          '<input type="hidden" name="id" value="' + variant.id + '">' +
          '<button type="submit" class="button button--primary sw-pc__btn">{label}</button>' +
        '</form>';
    return row({
      store: OUR_STORE,
      price: soldout ? null : p.price,
      region: 'ca',
      cta: cta
    });
  }

  function usRow(el, p) {
    /* data-us-url is built at publish time and already carries the referral
       parameter and the subid naming this article. The fallback is only for tiles
       written before that existed. */
    var url = el.getAttribute('data-us-url') ||
              (US_ORIGIN + '/products/' + el.getAttribute('data-us-handle') + US_REF);

    /* Sold out at the retailer: drop the primary styling and the price, and keep
       the plain "Buy from X" wording. It used to say "Sold out at X", which
       published another shop's stock status (see enrichStoreCtas below). */
    var soldout = p && p.available === false;
    var cls = soldout ? 'button sw-pc__btn' : 'button button--primary sw-pc__btn';

    return row({
      store: US_STORE,
      price: soldout ? null : (p ? p.price : null),
      region: 'us',
      /* data-store-name and data-gear-paid are read by gear-cta-click.js, so a
         tile click reports the same partner name and paid flag as a card's. The
         Espresso Parts link always carries our Refersion referral, so it is paid. */
      cta: '<a class="' + cls + '" href="' + esc(url) + '"' +
           ' data-store-name="' + esc(US_STORE) + '" data-gear-paid="paid"' +
           ' target="_blank" rel="sponsored nofollow noopener">' +
           '{label}</a>'
    });
  }

  function render(el) {
    var ours = el.getAttribute('data-handle');
    var theirs = el.getAttribute('data-us-handle');
    if (!ours && !theirs) { el.remove(); return; }

    Promise.all([
      fetchProduct('', ours),
      fetchProduct(US_ORIGIN, theirs)
    ]).then(function (res) {
      var p = res[0], up = res[1];

      /* A tile that can name no store at all is worse than no tile. */
      if (!p && !up) { el.remove(); return; }

      var title = (p && p.title) || (up && up.title) || el.getAttribute('data-title') || '';
      var image = (p && p.featured_image) || (up && up.featured_image) || '';
      var rows = (p ? ourRow(p) : '') + (theirs ? usRow(el, up) : '');

      el.innerHTML =
        (image
          ? '<div class="sw-pc__media"><img src="' + imgUrl(image) + '" alt="' + esc(title) +
            '" loading="lazy"></div>'
          : '') +
        '<div class="sw-pc__body">' +
          '<p class="sw-pc__title">' + esc(title) + '</p>' +
          '<div class="sw-pc__rows">' + rows + '</div>' +
          (theirs
            ? '<p class="sw-pc__disclosure" data-gear-region-item="us">The ' + US_STORE +
              ' link earns us a commission. It does not change what you pay.</p>'
            : '') +
        '</div>';

      el.classList.add('is-loaded');

      /* Nothing on this tile is buyable from Canada, so hide the whole thing there
         rather than showing a card with no usable row. */
      if (!p && theirs) el.setAttribute('data-gear-region-item', 'us');
      else if (p && !theirs) el.setAttribute('data-gear-region-item', 'ca');
    }).catch(function () { el.remove(); });
  }


  /* Retailer buttons rendered by Liquid (the gear-article cards) arrive as
     "Buy from Espresso Parts" and get upgraded here to "$399.95 from Espresso
     Parts". Liquid cannot know another store's price, and a price pasted into the
     metafield would be stale the day they change it. If the fetch never lands the
     button keeps its original wording, which is still a complete call to action. */
  function enrichStoreCtas(root) {
    (root || document).querySelectorAll('[data-store-cta]:not([data-store-priced])')
      .forEach(function (el) {
        el.setAttribute('data-store-priced', '');
        var store = el.getAttribute('data-store-name') || '';
        var m = (el.getAttribute('href') || '').match(/^(https?:\/\/[^/]+)\/products\/([^?#/]+)/);
        if (!m) return;
        fetchProduct(m[1], m[2]).then(function (p) {
          if (!p) return;
          if (p.available === false) {
            /* Out of stock at the retailer: drop the primary styling and leave
               the button's original wording, which is a plain "Buy from X".

               It used to say "Sold out at X". That published another shop's
               stock status, which PICKS-WE-DONT-SELL.md section 4 bans for the
               same reasons we never publish our own: it is stale within the
               week, and it argues the reader out of the click. The reader can
               see the retailer's stock on the retailer's page.

               No price is appended either, because quoting a price beside a
               button for something that cannot currently be bought is the part
               that would actually mislead. */
            el.classList.remove('button--primary');
            return;
          }
          if (p.price == null) return;
          el.textContent = money(p.price) + ' from ' + store;
        });
      });
  }

  function init(root) {
    (root || document).querySelectorAll('.sw-product-card:not(.is-loaded)').forEach(render);
    enrichStoreCtas(root);
  }

  window.SWProductCard = { init: init, hydrate: render };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
})();
